import { c as _c } from "react/compiler-runtime";
import { Col, Container, Row } from "react-bootstrap";
import Image from "next/image";
import { AboutSection } from "@/enums";
import Link from "next/link";
export default function AboutMemes() {
  const $ = _c(17);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col><h1>Memes Are The Most Important Thing In The World</h1></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Row className="pt-2 pb-2"><Col className="pt-3 pb-3 text-center"><Image unoptimized={true} loading="eager" priority={true} width="0" height="0" style={{
          height: "auto",
          width: "auto",
          maxHeight: "400px",
          maxWidth: "100%"
        }} src="/memes-preview.png" alt="The Memes" /></Col></Row>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t10;
  let t11;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p>Memes are intersubjective myths.</p>;
    t3 = <p>Memes are how all advanced societies organize themselves across large groups of people.{" "}</p>;
    t4 = <p>Elections, politics, culture, brands, consumer behavior, cash-flows all derive from the most powerful memes in society at any given point in time.</p>;
    t5 = <br />;
    t6 = <p><b>The Memes</b></p>;
    t7 = <p>The Memes is a collection of art NFTs whose goal is to spread the message of decentralization, in a way that tweetstorms, policy papers and podcasts can't.</p>;
    t8 = <p>The Memes are large edition, CCO (public domain) NFTs that are actively encouraged to be spread far and wide, to be remixed, to be rememed and to be reinterpreted by the world at large.</p>;
    t9 = <p>We believe that permissionless NFTs on decentralized public blockchains should used as the default ownership layer for digital objects - profile pictures, avatars, art, virtual spaces, game objects, identities and so on - and that application providers should reference that ownership layer. This is what we call "the open metaverse". We think whether our digital objects are recorded in centralized corporate databased or user-owned public blockchains is the most consequential technology decision in our society right now.</p>;
    t10 = <br />;
    t11 = <p><b>Learn More About The Memes:</b></p>;
    $[2] = t10;
    $[3] = t11;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t10 = $[2];
    t11 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <p>All The Memes:{" "}<Link href="/the-memes" target="_blank" rel="noopener noreferrer">6529.io/the-memes</Link></p>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <p>The Memes Network:{" "}<Link href="/network" target="_blank" rel="noopener noreferrer">6529.io/network</Link></p>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <p>FAQs:{" "}<Link href={`/about/${AboutSection.FAQ}`} target="_blank" rel="noopener noreferrer">6529.io/about/faq</Link></p>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <p>The Memes chat on Brain:{" "}<Link href="https://6529.io/waves?wave=0849642f-1770-4de2-9cbc-70aae59c17ff">Memes-Chat</Link></p>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Container>{t0}{t1}<Row className="pt-3 pb-3"><Col>{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}<p>Minting Memes:{" "}<Link href={`/about/${AboutSection.MINTING}`} target="_blank" rel="noopener noreferrer">6529.io/about/minting</Link></p></Col></Row></Container>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  return t16;
}